import {AUTO_TAB_INDEX_DATA_ATTR} from '../DNFORM-utils/DNFORM-constants';

export const inputFocusHandlerMixin = {
	methods: {
 		setFocusOnPrevInput(targetInput, ref, shouldSetCallback) {
			const shouldSetFocus = shouldSetCallback(targetInput);

			if (shouldSetFocus) {
				const prevAutoTabIndex = Number(targetInput.dataset.autoTabIndex) - 1;

				if (this.$refs[ref]) {
					const prevInput = this.$refs[ref].querySelector(`[${AUTO_TAB_INDEX_DATA_ATTR}="${prevAutoTabIndex}"]`);

					if (prevInput) {
						prevInput.focus();
					}
				}

			}
		},
		setFocusOnNextInput(targetInput, ref, shouldSetCallback) {
			const shouldSetFocus = shouldSetCallback(targetInput);

			if (shouldSetFocus) {
				const nextAutoTabIndex = Number(targetInput.dataset.autoTabIndex) + 1;

				if (this.$refs[ref]) {
					const nextInput = this.$refs[ref].querySelector(`[${AUTO_TAB_INDEX_DATA_ATTR}="${nextAutoTabIndex}"]`);

					if (nextInput) {
						nextInput.focus();
					}
				}
			}
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-mixins/DNFORM-input-focus-handler-mixin.js